import { Modal } from "antd";
import React from "react";
import FormRateio from "./FormRateio";

interface ModalFormRateioProps {
  isOpenModal: boolean;
  onClose: () => any;
  year: string;
  month: string;
  rateioId?: string;
  nomeRateio?: string;
  rateioAberto?: boolean;
  onSuccess?: (id: string) => any;
}

function ModalFormRateio({
  isOpenModal,
  onClose,
  rateioId,
  year,
  month,
  nomeRateio,
  rateioAberto,
  onSuccess,
}: ModalFormRateioProps) {
  return (
    <Modal
      centered
      visible={isOpenModal}
      footer={null}
      destroyOnClose
      onCancel={onClose}
      closable={false}
      width="850px"
      bodyStyle={{
        maxHeight: "85vh",
        overflow: "auto",
        paddingBottom: 16,
      }}
    >
      <FormRateio
        rateioEditId={rateioId}
        rateioAberto={rateioAberto}
        year={year}
        month={month}
        nomeRateio={nomeRateio}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </Modal>
  );
}

export default ModalFormRateio;
